export default __webpack_public_path__ + "static/media/info.e66026e9.svg";